const FEATURE_HELP_URLS = {
  agent_bots: 'https://networkanalysers.com/chatafzar/',
  agents: 'https://networkanalysers.com/chatafzar/',
  audit_logs: 'https://networkanalysers.com/chatafzar/',
  campaigns: 'https://networkanalysers.com/chatafzar/',
  canned_responses: 'https://networkanalysers.com/chatafzar/',
  channel_email: 'https://networkanalysers.com/chatafzar/',
  channel_facebook: 'https://networkanalysers.com/chatafzar/',
  custom_attributes: 'https://networkanalysers.com/chatafzar/',
  dashboard_apps: 'https://networkanalysers.com/chatafzar/',
  help_center: 'https://networkanalysers.com/chatafzar/',
  inboxes: 'https://networkanalysers.com/chatafzar/',
  integrations: 'https://networkanalysers.com/chatafzar/',
  labels: 'https://networkanalysers.com/chatafzar/',
  macros: 'https://networkanalysers.com/chatafzar/',
  reports: 'https://networkanalysers.com/chatafzar/',
  sla: 'https://networkanalysers.com/chatafzar/',
  team_management: 'https://networkanalysers.com/chatafzar/',
  webhook: 'https://networkanalysers.com/chatafzar/',
  billing: 'https://networkanalysers.com/chatafzar/',
  saml: 'https://networkanalysers.com/chatafzar/',
  captain: 'https://networkanalysers.com/chatafzar/',
  captain_billing: 'https://networkanalysers.com/chatafzar/',
};

export function getHelpUrlForFeature(featureName) {
  return FEATURE_HELP_URLS[featureName];
}
